import { Grid, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { theme } from 'config';

export const LocationContainer = styled(Grid)({
  borderRadius: '4px',
  border: '2px solid #EBEBEB',
  padding: '20px',
  width: '100%',

  '&:first-of-type': {
    marginRight: '10px',
  },

  [theme.breakpoints.down('md')]: {
    '&:first-of-type': {
      marginRight: '0px',
      marginBottom: '10px',
    },
  },
  [theme.breakpoints.down('sm')]: {
    padding: '10px',
  },
});

export const RowWrapper = styled(Grid)({
  display: 'flex',
  justifyContent: 'space-between',
});

export const Wrapper = styled(Grid)(
  {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  ({ time_text }) => ({
    maxWidth: time_text === 'true' ? '130px' : 'auto',
    width: time_text === 'true' ? '100%' : 'auto',
  })
);

export const Title = styled(Typography)({
  fontSize: '12px',
});
export const Code = styled(Typography)({});
export const Time = styled(Typography)({
  fontSize: '24px',
});

export const Divider = styled(Grid)({
  height: '2px',
  width: '100%',
  margin: '20px 0',
  backgroundColor: '#EBEBEB',
});

export const Item = styled(Grid)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '5px',
});

export const Name = styled(Typography)({}, ({ airport }) => ({
  minWidth: airport === 'true' ? '70px' : '85px',
  fontSize: '12px',
}));

export const Value = styled(Typography)({
  marginLeft: '10px',
  fontSize: '12px',
});
